const secondary = {
    social_bind_with: 'Already had an account? Sign in to link {{methods, list(type: disjunction;)}} with your social identity.',
};
export default Object.freeze(secondary);
